/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.projects', {
            parent: 'member',
            url: '/member/projects/{type}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title2'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/projects/projects.html',
                    controller: 'ProjectsMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('sbfTimeSlot');
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        })
        .state('project.book', {
            parent: 'member.projects',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumCountry');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/projects/booking-dialog.html',
                    controller: 'MemberBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectBooking', function(ProjectBooking) {
                            return ProjectBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.projects', null, { reload: 'member.projects' });
                }, function() {
                    $state.go('member.projects');
                });
            }]
        })
        .state('book-sbf-slot', {
            parent: 'member.projects',
            url: '/bookSbf/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/projects/book-sbf-slot-dialog.html',
                    controller: 'BookSbfSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlotMember', function(SbfTimeSlotMember) {
                            return SbfTimeSlotMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.projects', null, { reload: 'member.projects' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
